<template>
  <div class="patent-intro">
    <h2 data-aos="fade-in">专利介绍</h2>
    <h3 data-aos="fade-up">【 摘要 】</h3>
    <div class="info" data-aos="zoom-in-up">
      <p>{{ introduction }}</p>
    </div>
    <h3 data-aos="fade-up">【 服务流程 】</h3>
    <div class="patent-intro.img" data-aos="fade-up">
      <img src="../assets/trademarks/patent-intro.png" alt="" />
    </div>
    <h3 data-aos="fade-up">【 专利证书 】</h3>
    <ul>
      <li data-aos="zoom-in-up">
        <img src="../assets/trademarks/patent-1.png" alt="" />
      </li>
      <li data-aos="zoom-in-up">
        <img src="../assets/trademarks/patent-2.png" alt="" />
      </li>
      <li data-aos="zoom-in-up">
        <img src="../assets/trademarks/patent-3.png" alt="" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["introduction"],
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@include component(patent-intro) {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 38px 30px;
  color: #333333;
  font-size: 16px;
  > h2 {
    font-size: 24px;
    font-weight: bold;
    color: #f47227;
    line-height: 30px;
    margin: 0;
    text-align: left;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 20px;
    position: relative;
    &:before {
      display: inline-block;
      content: "";
      width: 100px;
      height: 5px;
      background: #f47227;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  > h3 {
    margin: 0;
    margin-top: 50px;
    font-size: 20px;
    font-weight: 500;
    color: #F47227;
    text-align: left;
    small {
      display: block;
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
  @include part(img) {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    img {
      display: block;
    }
  }
  > ul {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
  }
  .info {
    margin-top: 30px;
    p {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      text-align: left;
      text-indent: 40px;
      line-height: 30px;
    }
  }
}
</style>
